var map = {
  "./facebook.svg": "4690",
  "./instagram.svg": "3478",
  "./linkedin.svg": "7128",
  "./play-circle-firefly.svg": "2085",
  "./play-circle.svg": "2393",
  "./tiktok.svg": "9480",
  "./x.svg": "6314",
  "./youtube.svg": "261"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 3310;
